<template>
  <div>
    <NotificacoesOperacaoCard
      :visible="cardVisible"
      :map-enabled="isOperacaoRoute"
      :items="notificacoesImportantes"
      :total-count="notificacoesImportantes.length"
      :max-list-height="listMaxHeightPx"
      :title="$t('operation.activeNotifications')"
      @item-click="onItemClick"
      @tratar="onTratar"
      @ver-mais="onVerMais"
    />

    <v-dialog v-model="confirmResetDialog" persistent max-width="500" style="z-index: 3000">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('system.alert') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ $t('operation.confirmReset') }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmResetDialog = false">
            {{ $t('button.cancel') }}
          </v-btn>
          <v-btn color="red accent-4" class="white--text" @click="resetNotificacao">
            {{ $t('button.confirmOk') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import DateUtils from "@/utils/dateutils";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import { openNotificacoesDia } from "@/utils/openNotificacoesDia";
import {
  resolveNotificacaoPath,
  notificacaoPertenceAoUsuario,
} from "@/utils/notificacaoVisibilidade";
import NotificacoesOperacaoCard from "./NotificacoesOperacaoCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "NotificacoesOperacaoHost",
  components: {
    NotificacoesOperacaoCard,
  },
  data() {
    return {
      cardVisible: false,
      isPlugin: false,
      pollingActive: false,
      pollTimer: null,
      config: null,
      configLoading: false,
      linhas: [],
      empresasPermitidas: [],
      limiteAlertasTela: 3,
      totalAnterior: null,
      notificacoesImportantes: [],
      confirmResetDialog: false,
      notifToReset: null,
      beepAudio: null,
    };
  },
  computed: {
    ...mapGetters("user", {
      is_superadmin: "super",
    }),
    ...mapGetters("config", {
      tempoAtualizacaoNotificacoes: "tempoAtualizacaoNotificacoesAjustado",
    }),
    isOperacaoRoute() {
      return Boolean(this.$route && this.$route.name === "Operacao");
    },
    canPoll() {
      if (this.isPlugin) {
        return false;
      }
      const token = sessionStorage.getItem("api");
      const user = sessionStorage.getItem("user");
      return Boolean(token && user);
    },
    idsLinhasPermitidas() {
      return new Set(this.linhas.map((l) => String(l.id_linha)));
    },
    idsEmpresasPermitidas() {
      return new Set(
        (Array.isArray(this.empresasPermitidas) ? this.empresasPermitidas : []).map((id) =>
          String(id)
        )
      );
    },
    listMaxHeightPx() {
      const slots = Number(this.limiteAlertasTela) || 3;
      const itemRowPx = 62;
      const listPadPx = 8;
      return slots * itemRowPx + listPadPx;
    },
  },
  watch: {
    cardVisible(val) {
      EventBus.$emit("operacao-notificacoes-visible", val);
    },
    $route(to) {
      if (!to || !to.meta || !to.meta.requiresAuth) {
        this.stopPolling();
        this.cardVisible = false;
        this.notificacoesImportantes = [];
        this.totalAnterior = null;
        EventBus.$emit("operacao-notificacoes-count", 0);
        return;
      }
      this.syncPolling();
    },
  },
  mounted() {
    EventBus.$on("operacao-notificacoes-click", this.onNavBarClick);
    EventBus.$on("operacao-notificacoes-refresh", this.onRefresh);
    EventBus.$on("setPlugin", this.onPluginChanged);
    this.$root.$on("setPlugin", this.onPluginChanged);
    this.$root.$on("setUser", this.onUserChanged);

    EventBus.$emit("operacao-notificacoes-visible", this.cardVisible);
    this.syncPolling();
  },
  beforeDestroy() {
    this.stopPolling();
    EventBus.$emit("operacao-notificacoes-count", 0);
    EventBus.$emit("operacao-notificacoes-visible", false);
    EventBus.$off("operacao-notificacoes-click", this.onNavBarClick);
    EventBus.$off("operacao-notificacoes-refresh", this.onRefresh);
    EventBus.$off("setPlugin", this.onPluginChanged);
    this.$root.$off("setPlugin", this.onPluginChanged);
    this.$root.$off("setUser", this.onUserChanged);
  },
  methods: {
    onNavBarClick() {
      this.cardVisible = !this.cardVisible;
    },
    onRefresh() {
      if (this.canPoll) {
        this.populaCountNotificacoes();
      }
    },
    onPluginChanged(value) {
      this.isPlugin = Boolean(value);
      this.syncPolling();
    },
    onUserChanged() {
      this.syncPolling();
    },
    syncPolling() {
      if (this.canPoll) {
        this.startPolling();
      } else {
        this.stopPolling();
        this.cardVisible = false;
        this.notificacoesImportantes = [];
        this.totalAnterior = null;
        EventBus.$emit("operacao-notificacoes-count", 0);
      }
    },
    startPolling() {
      if (this.pollingActive) {
        return;
      }
      this.pollingActive = true;
      this.loadLinhasAndStart();
    },
    stopPolling() {
      this.pollingActive = false;
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
    },
    scheduleNext() {
      if (!this.pollingActive) {
        return;
      }
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
      }
      const delay = this.tempoAtualizacaoNotificacoes || 60000;
      this.pollTimer = setTimeout(() => {
        if (!this.pollingActive) {
          return;
        }
        this.populaCountNotificacoes();
      }, delay);
    },
    loadLinhasAndStart() {
      if (!this.pollingActive) {
        return;
      }
      let user = null;
      try {
        user = JSON.parse(sessionStorage.getItem("user"));
      } catch (e) {
        user = null;
      }
      const idUsuario = user && user.id_usuario;

      const afterRecursos = (recursos) => {
        if (!this.pollingActive) {
          return;
        }
        const list = Array.isArray(recursos) ? recursos : [];
        this.empresasPermitidas = list
          .filter((r) => r && r.id_empresa != null)
          .map((r) => r.id_empresa);
        this.populaLinhas();
      };

      if (this.is_superadmin) {
        apiController.request(apiController.endpoints.getallRecursos, {
          silent: true,
          onSuccess: (response) => afterRecursos(response.data),
          onError: () => {
            this.empresasPermitidas = [];
            this.populaLinhas();
          },
        });
      } else if (idUsuario != null) {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: idUsuario },
          silent: true,
          onSuccess: (response) => afterRecursos(response.data),
          onError: () => {
            this.empresasPermitidas = [];
            this.populaLinhas();
          },
        });
      } else {
        this.empresasPermitidas = [];
        this.populaLinhas();
      }
    },
    populaLinhas() {
      if (!this.pollingActive) {
        return;
      }
      apiController.request(apiController.endpoints.getLinhasoperacao, {
        silent: true,
        onSuccess: (response) => {
          if (!this.pollingActive) {
            return;
          }
          if (!response || !Array.isArray(response.data)) {
            this.linhas = [];
          } else {
            const empresas = Array.isArray(this.empresasPermitidas)
              ? this.empresasPermitidas
              : [];
            this.linhas = response.data.filter((l) => {
              if (!l || typeof l !== "object") {
                return false;
              }
              return empresas.includes(l.id_empresa);
            });
          }
          this.populaCountNotificacoes();
        },
        onError: () => {
          this.linhas = [];
          this.populaCountNotificacoes();
        },
      });
    },
    applyActiveCount(total) {
      const n = Number(total) || 0;
      if (this.totalAnterior != null && n > this.totalAnterior) {
        this.beep();
      }
      this.totalAnterior = n;
      EventBus.$emit("operacao-notificacoes-count", n);
    },
    belongsToUserClient(notif) {
      return notificacaoPertenceAoUsuario({
        notif,
        isSuperadmin: this.is_superadmin,
        idsLinhas: this.idsLinhasPermitidas,
        idsEmpresas: this.idsEmpresasPermitidas,
      });
    },
    populaCountNotificacoes() {
      if (!this.pollingActive) {
        return;
      }
      // Sem cliente no escopo do usuário, não há o que exibir (superadmin segue).
      if (!this.is_superadmin && this.idsEmpresasPermitidas.size === 0) {
        this.notificacoesImportantes = [];
        this.applyActiveCount(0);
        this.scheduleNext();
        return;
      }
      this.populaNotificacoesImportantes();
    },
    populaNotificacoesImportantes() {
      if (!this.pollingActive) {
        return;
      }
      if (!this.config || this.config.periodo_busca_alertas_minutos == null) {
        if (!this.configLoading) {
          this.configLoading = true;
          this.getConfig().finally(() => {
            this.configLoading = false;
            if (this.pollingActive) {
              this.populaNotificacoesImportantes();
            }
          });
        }
        return;
      }

      const periodoMinutos = this.config.periodo_busca_alertas_minutos || 1440;
      const dtinicio = new Date();
      dtinicio.setMinutes(dtinicio.getMinutes() - periodoMinutos);
      const dti = DateUtils.getDateSQLFormatted(dtinicio);
      const dtf = DateUtils.getDateSQLFormatted(new Date());

      const payload = { dtinicio: dti, dtfim: dtf };
      // Escopo de cliente na API (não-superadmin): evita vazar notificações de outros tenants.
      if (!this.is_superadmin && this.empresasPermitidas.length > 0) {
        payload.idempresa = this.empresasPermitidas;
      }

      apiController.request(apiController.endpoints.getNotificacoespordata, {
        data: payload,
        silent: true,
        onSuccess: (response) => {
          if (!this.pollingActive) {
            return;
          }
          if (!Array.isArray(response.data)) {
            this.notificacoesImportantes = [];
            this.applyActiveCount(0);
            this.scheduleNext();
            return;
          }
          let list = response.data.map((n) => ({
            ...n,
            path: resolveNotificacaoPath(n),
            descricao_tipo_notificacao: translateDbField(
              n.translation_key,
              n.descricao_tipo_notificacao
            ),
          }));
          list = list.filter((n) => this.belongsToUserClient(n));
          const notifs = list
            .filter((n) => Number(n.show_alerta) === 1 && Number(n.reset) === 0)
            .map((n) => ({
              notificacao: n,
              color: n.cor,
            }));

          this.notificacoesImportantes = notifs;
          // Sino e card usam a mesma lista filtrada.
          this.applyActiveCount(notifs.length);
          this.scheduleNext();
        },
        onError: () => {
          this.scheduleNext();
        },
      });
    },
    getConfig() {
      return apiController
        .request(apiController.endpoints.getallConfig, {
          silent: true,
          onSuccess: (response) => {
            if (Array.isArray(response.data) && response.data[0]) {
              this.config = response.data[0];
              if (this.config.limite_alertas_tela != null) {
                this.limiteAlertasTela = this.config.limite_alertas_tela;
              }
            } else {
              this.config = { periodo_busca_alertas_minutos: 1440 };
            }
          },
          onError: () => {
            this.config = { periodo_busca_alertas_minutos: 1440 };
          },
        })
        .catch(() => {
          this.config = { periodo_busca_alertas_minutos: 1440 };
        });
    },
    beep() {
      if (!this.beepAudio) {
        this.beepAudio = new Audio("beep.mp3");
      }
      this.beepAudio.play();
    },
    onItemClick(notif, color) {
      const path = resolveNotificacaoPath(notif);
      if (!path) {
        return;
      }
      const currentPath = this.$route && this.$route.path ? this.$route.path : "";
      // Alerta de equipamento abre a tela de Equipamentos já no veículo do aparelho.
      if (path === "/equipamentos" && notif.id_equipamento != null) {
        const equipamento = String(notif.id_equipamento);
        if (currentPath !== path || (this.$route.query || {}).equipamento !== equipamento) {
          this.$router.push({ path, query: { equipamento } });
        }
        return;
      }
      if (currentPath === path) {
        if (path === "/operacao") {
          EventBus.$emit("operacao-notificacao-abrir-mapa", { notif, color });
        }
        return;
      }
      this.$router.push(path);
    },
    onTratar(notificacao) {
      this.notifToReset = notificacao;
      this.confirmResetDialog = true;
    },
    onVerMais() {
      openNotificacoesDia(this.$router, { source: "card" });
    },
    resetNotificacao() {
      this.confirmResetDialog = false;
      if (!this.notifToReset) {
        return;
      }
      const id = this.notifToReset.id_notificacao;
      apiController.request(apiController.endpoints.updateNotificacao, {
        data: { id_notificacao: id },
        silent: true,
        onSuccess: () => {
          this.notifToReset = null;
          EventBus.$emit("operacao-notificacao-tratada", id);
          this.populaCountNotificacoes();
        },
        onError: (e) => {
          console.log("Response : " + (e && e.message));
          this.notifToReset = null;
        },
      });
    },
  },
};
</script>
